import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Dropdown, Datepicker } from "flowbite-react";
import { FiInbox } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { agentGroupQuery, getChatHistory, getConversation, getInboxSettings, getTenantUsers, liveChatContactSearch, liveChatUpdateContacts, tagQuery } from "../../store/actions/tenantAction";
import { allTags, priorityTextColor, toTitleCase } from '../../utils/helper';
import * as XLSX from "xlsx";
import RightSidePanel from '../../components/RightSidePanel';
import LiveChatUserInfo from '../../layouts/globalAdmin/LiveChatUserInfo';
import PopUp from '../../components/PopUp';
import { SendTemplateMsgBackground } from '../../layouts/tenant/SendTemplateMsgBackground';
import AssignChat from '../../layouts/tenant/AssignChat';

function MobileViewLiveChatHeader({ selectedContact, setSelectedContact, selectedTags, setSelectedTags, agents, agentGroup, setAddNumber }) {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const [showTags, setShowTags] = useState(false);
    const [showPriorityPopup, setShowPriorityPopup] = useState(false);
    const [showAssignTicket, setShowAssignTicket] = useState(false);
    const [closeChat, setCloseChat] = useState(false);
    const [viewUserInfo, setViewUserInfo] = useState(false);
    const globalReducer = useSelector((state) => state.globalReducer);
    const [showDropdown, setShowDropdown] = useState(true);
    const closeChatTemplateRef = useRef();
    const [inboxSettings, setInboxSettings] = useState({});

    const getContactDetails = () => {
        if (selectedContact?.id && globalReducer.loginInfo?.tenantId && globalReducer.waba?.id) {
            dispatch(liveChatContactSearch({
                criteria: { id: selectedContact?.id }
            }, s => {
                if (Array.isArray(s?.data) && s?.data?.length > 0) {
                    setSelectedContact(s?.data[0]);
                }
            }));
        }
    };

    const updateTicket = (data) => {
        dispatch(liveChatUpdateContacts(data, (a) => {
            setCloseChat(false);
            setShowAssignTicket(false);
            setShowPriorityPopup(false);
            getContactDetails();
        }));
    }

    const exportReport = () => {
        dispatch(getConversation({
            criteria: { contactId: selectedContact?.contact?.id, tenantWabaId: globalReducer.waba?.id, tenantId: globalReducer.loginInfo?.tenantId },
            tenantId: globalReducer.loginInfo?.tenantId,
            count: true,
            size: 10000,
            offset: 0,
            orderBy: [{ property: "id", direction: "DESC" }]
        }, (d) => {
            const data = d?.data?.map(m => {
                return {
                    id: m.id,
                    waba: `${globalReducer.waba?.teamName ?? ""}  ${globalReducer.waba?.phoneCode ? "+" + globalReducer.waba?.phoneCode : ""} ${globalReducer.waba?.phone ?? ""}`,
                    whatsappNumber: m?.contact?.whatsappNumber,
                    messageType: m.messageType,
                    type: m.type,
                    templateName: m.templateName,
                    currencyCode: m.currencyCode,
                    countryCode: m.countryCode,
                    languageCode: m.languageCode,
                    amount: m.amount,
                    messageText: m.messageText,
                    referenceId: m.referenceId,
                    messageStatus: m.messageStatus,
                    remarks: m.remarks,
                    reply: m.reply,
                    createdAt: m.createdAt,
                }
            })
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(data ?? []);
            XLSX.utils.book_append_sheet(workbook, worksheet, "live_chat");
            XLSX.writeFile(workbook, 'live_chat_report.xlsx');
        }));
    };

    return (
        <div className="flex items-center justify-between px-2 sm:px-4 py-2 h-[53.8px] text-base bg-white border-b-[1px] border-[#e9ebf0] border-solid">
            <div className="flex items-center gap-1.5 font-medium text-black whitespace-nowrap shrink-0">
                <div className="text-[15px] font-medium" onClick={() => {
                    try {
                        window.FlutterLogger.postMessage(JSON.stringify({ type: "BACK_BTN_CLICK", data: selectedContact }));
                    } catch { }
                }}><i className="fa-solid fa-angle-left pr-2 pl-1"></i>{selectedContact?.contact?.name?.substring(0, 30) || 'Live Chat'}</div>
            </div>
            <div className="flex items-center justify-end gap-1.5 min-w-0">
                <div className="relative inline-flex items-center shrink-0">
                    {/* <button onClick={() => { setShowTags(!showTags); }} className="inline-flex items-center rounded-md p-1.5 text-center justify-center font-medium outline-none focus:outline-none transition ease-out duration-200 bg-white">
                        <svg width={16} height={16} fill="#6B7280" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#6B7280" fillRule="evenodd" d="M19.248 9.151a1.2 1.2 0 0 1 0 1.697l-8.4 8.4a1.2 1.2 0 0 1-1.697 0l-8.4-8.4A1.196 1.196 0 0 1 .4 10V4A3.6 3.6 0 0 1 4 .4h6c.307 0 .614.117.848.351l8.4 8.4ZM4 5.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" clipRule="evenodd" />
                        </svg>
                        <div className="flex gap-1 pl-2">
                            {selectedContact?.tags?.map((tg, i) => <div key={i} className="ml-1 px-1 bg-gray-100 text-xs font-medium text-gray-800 rounded">{tg}</div>)}
                        </div>
                    </button> */}
                    {/* <label className="text-[12px] ml-0.5 whitespace-nowrap hidden sm:inline">{selectedContact?.ticketNumber}</label> */}
                    {showTags && <div className="absolute right-[-30px] top-6 z-20 mt-1 bg-white rounded-md shadow-lg w-[255px] ring-0 ring-black ring-opacity-5 focus:outline-none">
                        <div className="p-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-semibold text-gray-800">Tags</label>
                                <div onClick={() => setShowTags(false)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="w-5 h-5 text-gray-500 cursor-pointer">
                                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-md shadow-lg sm:text-sm">
                            <div className="px-3">
                                <div className="text-[#0078CF] cursor-pointer" onClick={() => { selectedTags?.map(st => { st.checked = false }); setSelectedTags([...selectedTags]); }}>Unselect all</div>
                            </div>
                            <div className="items-center overflow-auto max-h-60">
                                {selectedTags?.map((st, i) =>
                                    <div className="flex px-3 py-2.5" key={i}>
                                        <div className="flex items-center h-5">
                                            <input type="checkbox" checked={st?.checked} className="w-4 h-4 border-gray-300 rounded text-primary focus:ring-primary"
                                                onChange={(e) => { selectedTags[i].checked = e.target.checked; setSelectedTags([...selectedTags]); }} />
                                        </div>
                                        <div className="flex w-full ml-2 mr-2 text-sm text-left">
                                            <div className="w-[95%]">
                                                <span className="block truncate text-sm font-normal text-gray-900">{st.text}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="sticky flex w-full h-[46px] p-1.5 bg-white border-t justify-between rounded-b-md">
                                <div className="content-center justify-start px-1" />
                                <div className="justify-end flex gap-3">
                                    <button className="inline-flex items-center text-center px-2.5 py-1.5 text-xs rounded border font-medium outline-none border-gray-300 bg-white hover:border-primary focus:outline-none transition ease-out duration-200 text-gray-700" onClick={() => setShowTags(false)}>
                                        {t("Cancel")}
                                    </button>
                                    <button className="inline-flex items-center text-center px-2.5 py-1.5 text-xs rounded border font-medium outline-none border-gray-300 bg-white hover:border-primary focus:outline-none transition ease-out duration-200 bg-theme"
                                        onClick={(e) => { updateTicket({ "ids": [selectedContact?.id], "tags": selectedTags?.filter(f => f.checked).map(m => m.text) }); setShowTags(false); }}>{t("Save Changes")}</button>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                {showPriorityPopup && <div className="relative">
                    <div className="absolute z-50 mt-2 w-[180px] top-6 right-0 bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg ring-0 ring-black ring-opacity-5 focus:outline-none">
                        <div className="p-3">
                            <div className="flex justify-between">
                                <label className="block text-sm font-semibold text-gray-800">Priority</label>
                                <div onClick={() => setShowPriorityPopup(false)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="w-5 h-5 text-gray-500 cursor-pointer">
                                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="py-1">
                            {["LOW", "MEDIUM", "HIGH", "URGENT"].map((item, i) => (
                                <div key={i} className="px-4 py-2 flex justify-between items-center border-b hover:bg-gray-50" onClick={() => updateTicket({ "ids": [selectedContact?.id], "priority": item })}>
                                    <p className={"text-[14px] text-" + priorityTextColor[item]}>{toTitleCase(item.toLowerCase())}</p>
                                    <p className={"text-[14px] text-" + priorityTextColor[item]}>{item === selectedContact?.priority && <i className="fa-solid fa-check"></i>}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>}
                {/* <button type="button" aria-haspopup="menu" className="flex items-center px-1.5 py-1 space-x-1 bg-white border border-dashed rounded-md shadow-sm focus:outline-none shrink-0">
                    <div className="flex items-center gap-1" onClick={() => setShowPriorityPopup(!showPriorityPopup)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-flag">
                            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                            <line x1={4} x2={4} y1={22} y2={15} />
                        </svg>
                        <label className={"text-[12px] sm:inline text-" + priorityTextColor[selectedContact?.priority]}>{toTitleCase(selectedContact?.priority?.toLowerCase())}</label>
                        {showPriorityPopup && <div className="relative">
                            <div className="absolute z-50 mt-2 w-[180px] top-6 right-0 bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg ring-0 ring-black ring-opacity-5 focus:outline-none">
                                <div className="py-1">
                                    {["LOW", "MEDIUM", "HIGH", "URGENT"].map((item, i) => (
                                        <div key={i} className="px-4 py-2 flex justify-between items-center border-b hover:bg-gray-50" onClick={() => updateTicket({ "ids": [selectedContact?.id], "priority": item })}>
                                            <p className={"text-[14px] text-" + priorityTextColor[item]}>{toTitleCase(item.toLowerCase())}</p>
                                            <p className={"text-[14px] text-" + priorityTextColor[item]}>{item === selectedContact?.priority && <i className="fa-solid fa-check"></i>}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>}
                    </div>
                    <div className="shrink-0 border-l w-[1px] h-3.5 mx-1 bg-gray-300" />
                    <div className="flex items-center px-1 py-[1.5px] space-x-1 border rounded-md h-[20px] w-fit">
                        <span className={`w-[6px] h-[6px] rounded-full flex-shrink-0 ${selectedContact?.ticketStatus === "OPEN" ? "bg-[#04B25F]" : "bg-gray-500"}`} />
                        <span className={`text-[10px] whitespace-nowrap ${selectedContact?.ticketStatus === "OPEN" ? "text-[#04B25F]" : "text-gray-500"}`}>{selectedContact?.ticketStatus}</span>
                    </div>
                </button> */}
                <div className="border w-8 h-8 border-gray-300 rounded-md flex items-center justify-center shrink-0">
                    <Dropdown open={showDropdown} onOpenChange={setShowDropdown} inline arrowIcon={false} inputMode as="button" label={<i className="fa-solid fa-ellipsis"></i>}
                        className="font-medium text-[14px] text-gray-600 whitespace-nowrap hover:text-[#7A14FF] cursor-pointer bg-white">
                        <Dropdown.Item className="hover:text-theme" onClick={() => {
                            try {
                                window.FlutterLogger.postMessage(JSON.stringify({ type: "PROFILE_CLICK", data: selectedContact }));
                            } catch { }
                        }}>
                            <i className="fa-solid fa-circle-info pr-3"></i>{t('Profile')}
                        </Dropdown.Item>
                        {selectedContact?.ticketStatus === "OPEN"
                            ? <Dropdown.Item className="hover:text-theme" onClick={() => setCloseChat(true)}>
                                <i className="fa-regular fa-comment pr-2"></i> {t('Close Chat')}
                            </Dropdown.Item>
                            : <Dropdown.Item className="hover:text-theme" onClick={() => updateTicket({ "ids": [selectedContact?.id], "ticket_status": "OPEN" })}>
                                <i className="fa-regular fa-comment pr-2"></i> {t('Open Chat')}
                            </Dropdown.Item>
                        }
                        {selectedContact?.ticketStatus === "OPEN"
                            ? <Dropdown.Item className="hover:text-theme" onClick={() => { updateTicket({ "ids": [selectedContact?.id], "ticket_status": "HOLD" }) }}>
                                <i className="fa-regular fa-circle-pause pr-2"></i> {t('Hold Ticket')}
                            </Dropdown.Item>
                            : <Dropdown.Item className="hover:text-theme" onClick={() => { updateTicket({ "ids": [selectedContact?.id], "ticket_status": "OPEN" }) }}>
                                <i className="fa-regular fa-circle-pause pr-2"></i> {t('Resume Ticket')}
                            </Dropdown.Item>}
                        {/* <Dropdown.Item className="hover:text-theme" onClick={() => exportReport()}>
                            <i className="fa-solid fa-table pr-2"></i> {t('Download as Report')}
                        </Dropdown.Item> */}
                        {/* <Dropdown.Item className="hover:text-theme" onClick={() => setAddNumber(true)}>
                            <i className="fa-solid fa-pen-to-square text-[#6B7280] pr-2"></i> {t('New Chat')}
                        </Dropdown.Item> */}
                        <Dropdown.Item className="hover:text-theme" onClick={() => setShowAssignTicket(true)}>
                            <i className="fa-solid fa-message pr-2"></i> Assign Ticket
                        </Dropdown.Item>
                        <Dropdown.Item className="hover:text-theme" onClick={() => { setShowTags(!showTags); }}>
                            <button className="inline-flex items-center rounded-md text-center justify-center">
                                <svg width={16} height={16} fill="#37383b" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#37383b" fillRule="evenodd" d="M19.248 9.151a1.2 1.2 0 0 1 0 1.697l-8.4 8.4a1.2 1.2 0 0 1-1.697 0l-8.4-8.4A1.196 1.196 0 0 1 .4 10V4A3.6 3.6 0 0 1 4 .4h6c.307 0 .614.117.848.351l8.4 8.4ZM4 5.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" clipRule="evenodd" />
                                </svg>
                                <div className="flex gap-1">
                                    {selectedContact?.tags?.map((tg, i) => <div key={i} className="ml-1 px-1 text-xs font-medium rounded">{tg}</div>)}
                                </div>
                            </button>
                        </Dropdown.Item>
                        <Dropdown.Item className="hover:text-theme" onClick={() => setShowPriorityPopup(!showPriorityPopup)}>
                            <button type="button" aria-haspopup="menu" className="flex items-center space-x-1 bg-white">
                                <div className="flex items-center gap-1" onClick={() => { }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-flag">
                                        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                                        <line x1={4} x2={4} y1={22} y2={15} />
                                    </svg>
                                    <label className={"text-[12px] sm:inline text-" + priorityTextColor[selectedContact?.priority]}>{toTitleCase(selectedContact?.priority?.toLowerCase())}</label>
                                    {showPriorityPopup && <div className="relative">
                                        <div className="absolute z-50 mt-2 w-[180px] top-6 right-0 bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg ring-0 ring-black ring-opacity-5 focus:outline-none">
                                            <div className="py-1">
                                                {["LOW", "MEDIUM", "HIGH", "URGENT"].map((item, i) => (
                                                    <div key={i} className="px-4 py-2 flex justify-between items-center border-b hover:bg-gray-50" onClick={() => updateTicket({ "ids": [selectedContact?.id], "priority": item })}>
                                                        <p className={"text-[14px] text-" + priorityTextColor[item]}>{toTitleCase(item.toLowerCase())}</p>
                                                        <p className={"text-[14px] text-" + priorityTextColor[item]}>{item === selectedContact?.priority && <i className="fa-solid fa-check"></i>}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                <div className="shrink-0 border-l w-[1px] h-3.5 mx-1 bg-gray-300" />
                                <div className="flex items-center px-1 py-[1.5px] space-x-1 border rounded-md h-[20px] w-fit">
                                    <span className={`w-[6px] h-[6px] rounded-full flex-shrink-0 ${selectedContact?.ticketStatus === "OPEN" ? "bg-[#04B25F]" : "bg-gray-500"}`} />
                                    <span className={`text-[10px] whitespace-nowrap ${selectedContact?.ticketStatus === "OPEN" ? "text-[#04B25F]" : "text-gray-500"}`}>{selectedContact?.ticketStatus}</span>
                                </div>
                            </button>
                        </Dropdown.Item>
                        {selectedContact?.ticketStatus?.toLowerCase() === "blocked"
                            ? <Dropdown.Item className="hover:text-theme" onClick={() => { updateTicket({ "ids": [selectedContact?.id], "ticket_status": "OPEN" }) }}>
                                <i className="fa-solid fa-comment pr-2"></i> Unblock User
                            </Dropdown.Item>
                            : <Dropdown.Item className="hover:text-theme" onClick={() => { updateTicket({ "ids": [selectedContact?.id], "ticket_status": "BLOCKED" }) }}>
                                <i className="fa-solid fa-comment-slash pr-2"></i> Block User
                            </Dropdown.Item>}
                    </Dropdown>
                </div>
                {/* <div className="border w-9 h-9 p-3 border-gray-300 rounded-md cursor-pointer flex items-center justify-center" onClick={() => setViewUserInfo(!viewUserInfo)}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.74995 1.0835C8.08325 0.750196 8.58325 0.750196 8.91655 1.0835C9.24995 1.4168 9.24995 1.9168 8.91655 2.2502L6.16655 5.0002L8.91655 7.7502C9.08325 7.9168 9.16655 8.0835 9.16655 8.3335C9.16655 8.8335 8.83325 9.1668 8.33325 9.1668C8.08325 9.1668 7.91655 9.0835 7.74995 8.9168L4.41655 5.5835C4.08325 5.2502 4.08325 4.7502 4.41655 4.4168L7.74995 1.0835ZM1.66655 0.833496C2.16655 0.833496 2.49995 1.1668 2.49995 1.6668V8.3335C2.49995 8.8335 2.16655 9.1668 1.66655 9.1668C1.16655 9.1668 0.833252 8.8335 0.833252 8.3335V1.6668C0.833252 1.1668 1.16655 0.833496 1.66655 0.833496Z" fill="#6B7280" />
                    </svg>
                </div> */}
            </div>
            <RightSidePanel
                CustomClass="fixed md:w-[30%] border-l-[1px] top-[30px] right-0 z-[40] height30 transition-transform bg-white"
                isShow={viewUserInfo}
                setIsShow={setViewUserInfo}
                Component={
                    <LiveChatUserInfo setViewUserInfo={setViewUserInfo} contact={selectedContact} />
                }
            />
            <PopUp ModalHeader={
                <>
                    <div className="font-medium text-[18px] text-black">
                        {t('Are you sure to close chat?')}
                    </div>
                    <div className="font-medium text-[14px] text-[#6E6C6D]">
                        {t('You can open this chat anytime.')}
                    </div>
                </>}
                isShowModal={closeChat}
                setIsShowModal={setCloseChat}
                ModalBody={
                    <div className="flex justify-end gap-4 p-6" setCloseChat={setCloseChat}>
                        <button onClick={() => setCloseChat(false)} className="px-[16px] py-[6px] text-[#644d81] font-medium text-[14px] bg-[#ECF0F7] transition-all ease-in-out rounded cursor-pointer hover:bg-[#e4e8ef]">
                            {t('Cancel')}
                        </button>
                        <button onClick={() => {
                            updateTicket({ "ids": [selectedContact?.id], "ticket_status": "CLOSED" });
                            if (inboxSettings?.feedbackTemplateId && inboxSettings?.feedbackTemplateId != 0) {
                                closeChatTemplateRef.current.handleSubmit();
                            }
                        }} className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary">
                            {t('Close Chat')}
                        </button>
                        <SendTemplateMsgBackground ref={closeChatTemplateRef} isLiveChat={false} phoneNumbars={[selectedContact?.contact?.whatsappNumber]} selectedTemplateId={inboxSettings?.feedbackTemplateId} onDone={(d) => { }} />
                    </div>
                }
                size="md"
            />

            <PopUp
                ModalHeader={
                    <div className="font-medium text-sm">
                        {t('Assign Ticket')}
                    </div>
                }
                isShowModal={showAssignTicket}
                setIsShowModal={setShowAssignTicket}
                ModalBody={
                    <AssignChat contects={[selectedContact]} agents={agents} agentGroup={agentGroup} onAssignTicket={(t) => {
                        updateTicket(t);
                    }} />
                }
                size="sm"
            />
        </div >
    )
}

export default MobileViewLiveChatHeader